import { render, staticRenderFns } from "./socialMedia.vue?vue&type=template&id=5f8a44b3&"
import script from "./socialMedia.vue?vue&type=script&lang=js&"
export * from "./socialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports